import MapMaptiler from './MapMaptiler';

export default MapMaptiler;
